import React from 'react';
import Card from '../Card/Card';
import Image from '../Image';
import SignUpButton from '../SignUpButton';
import SignInLink from '../SignInLink';

if (process.browser) require('./PromoCard.scss');

const CallToAction = ({ track }) => {
  const tracking = subAction => ({ ...track, action: `${track.action}${subAction}` });

  return (
    <div className="call-to-action">
      <SignUpButton track={tracking('SignUp')}>Sign up here</SignUpButton>
      <div><span>Already have an account ?</span><SignInLink track={tracking('SignIn')}>Sign in</SignInLink></div>
    </div>
  );
};

const PromoImage = () => (
  <Image className="image" src="C-40-download_2x_1.png" />
);

const Title = ({ text }) => (
  <h3 className="title column xs-2-3">{text}</h3>
);

const Description = ({ text }) => (
  <div className="row">
    <div className="column d-1-2 xs-2-3">
      <p>{text}</p>
    </div>
  </div>
);

export default function PromoCard({ title, description, track }) {
  return (
    <Card className="promo secondary">
      <Title text={title} />
      <Description text={description} />
      <PromoImage />
      <CallToAction track={track} />
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/PromoCard/PromoCard.js